import { useMemo, type ReactNode } from 'react';
import { getCopy, type Locale } from '@nexa/content';
import { LocaleContext, type LocaleValue } from './localeContext.ts';

export interface LocaleProviderProps {
  readonly locale: Locale;
  readonly children: ReactNode;
}

/**
 * Locale KHÔNG đọc từ `navigator.language` hay cookie mà lấy từ CHÍNH ĐƯỜNG DẪN
 * (`/vi/...`, `/en/...`), do route truyền vào đây.
 *
 * Lý do: bản HTML prerender là tĩnh, một URL phải luôn ra đúng một ngôn ngữ. Nếu ngôn ngữ phụ
 * thuộc trạng thái trình duyệt thì crawler và người dùng thấy hai nội dung khác nhau trên cùng
 * một URL — đó là cloaking, và nó cũng làm hydrate lệch với HTML tĩnh.
 */
export function LocaleProvider({ locale, children }: LocaleProviderProps) {
  const value = useMemo<LocaleValue>(() => ({ locale, copy: getCopy(locale) }), [locale]);
  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}
